export enum ConditionalFieldsOperators {
  equals = 'Equals',
}
